import http from '@/core/http'
// eslint-disable-next-line
import { map } from 'lodash'

const state = {
  data: [],
  totalItens: 0
}

const actions = {
  getData: async ({ commit }, payload) => {
    const result = await http.get('bilhetes', { params: payload })
    commit('SET_DATA', result.data)
    return Promise.resolve(result)
  },

  cancelarBilhete : async (_, payload) => {
    const result = await http.delete('bilhetes', { params: payload })
    return Promise.resolve(result)
  },

  bilhetePremiado : async (_, payload) => {
    const result = await http.put('bilhetes', payload)
    return Promise.resolve(result)
  },

  getItem: ({ commit }, payload) => {
    commit('LISTA_ITEM', payload)
  },

  limparItem: ({ commit }) => {
    commit('LIMPAR_ITEM')
  },

  setHasMonthOrDate: ({ commit }, payload) => {
    commit('SET_HAS_MONTH_OR_DATE', payload)
  }
}

const mutations = {
  'SET_DATA' (state, payload) {
    console.log('payload', payload)
    state.data = payload.results
    state.totalItens = payload.totalItens
  }
}

const getters = {
  listaItens: state => state.data,
  totalItens: (state) => state.totalItens,
  transmissoes: state => state.transmissoes,
}

export default { namespaced: true, state, actions, mutations, getters }